import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=af5e323c&scoped=true&"
import script from "./Integrations.vue?vue&type=script&lang=js&"
export * from "./Integrations.vue?vue&type=script&lang=js&"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=af5e323c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5e323c",
  null
  
)

export default component.exports